import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CNHealthProblem } from 'src/app/models/cnhealthproblem';
import { ProblemService, ProblemServiceFilter, ProblemServiceSubject } from 'src/app/services/problem.service';

@Component({
  selector: 'app-problem-table',
  templateUrl: './problem-table.component.html',
  styleUrls: ['./problem-table.component.scss']
})
export class ProblemTableComponent implements OnInit {

  displayedColumns: string[] = ['problem'];
  public problems = new MatTableDataSource<CNHealthProblem>();
  public subject: ProblemServiceSubject;
  private myLocation = 'default';
  private myFilter = ProblemServiceFilter.all;

  @ViewChild('paginator', { static: true }) paginator;
  @Input() pageSize = 5;

  constructor(public problemservice: ProblemService, private ngZone: NgZone) { }

  ngOnInit(): void {
    this.problemservice.clear.subscribe(flag => {
      console.log('medications cleared');
      this.paginator.pageIndex = 0;
    });
  }

  @Input() set location(theLocation: string) {
    this.myLocation = theLocation;
    this.subject = this.problemservice.getSubject(this.myLocation, this.myFilter, true);
    this.subject.problems.subscribe(data => {
      this.problems.data = data;
    });
  }

  changePage(event: PageEvent): void {
    if (!this.subject) {
      return;
    }
    const newStart = event.pageIndex * event.pageSize;
    if (newStart !== this.subject.start) {
      this.subject.start = newStart;
    }
    if (this.subject.limit !== event.pageSize) {
      this.subject.limit = event.pageSize;
    }
  }
}
